export const SET_VALUE = 'SET_VALUE';
export const SET_RULES_LEGALITY_VALUE = 'SET_RULES_LEGALITY_VALUE';
export const SET_RULES_DATA = 'SET_RULES_DATA';
export const SET_RULES_DATA_CONDITION = 'SET_RULES_DATA_CONDITION';
export interface SetValueAction {
    type: typeof SET_VALUE;
    payload: [];
}
export interface SetRulesLegalityValueAction {
    type: typeof SET_RULES_LEGALITY_VALUE;
    payload: any;
}
export interface RulesData {
    type: typeof SET_RULES_DATA;
    payload: any;
}
export interface RulesDataCondition {
    type: typeof SET_RULES_DATA_CONDITION;
    payload: any;
}

export type AppActionTypes = SetValueAction | SetRulesLegalityValueAction | RulesData | RulesDataCondition;
